(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["orlivy-collection-clips"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('orlivy-collection-clips')) {
    customElements.define('orlivy-collection-clips', class extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;
        this.abortController = new AbortController();
        const { signal } = this.abortController;
        this.videos = Array.from(this.querySelectorAll('video[data-src]'));
        this.toggle = this.querySelector('.orl-clips__toggle');
        this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.connection = navigator.connection;
        this.playRequested = !this.motionPreference.matches && !this.connection?.saveData;
        this.inView = false;
        this.states = new Map(this.videos.map(video => [video, { pending: false, blocked: false, failed: false }]));
        this.toggle.hidden = false;

        this.videos.forEach(video => {
          video.muted = true;
          video.defaultMuted = true;
          video.addEventListener('playing', () => {
            if (!this.shouldPlay()) {
              video.pause();
              return;
            }
            video.closest('.orl-clips__card').classList.add('is-playing');
            this.updateButton();
          }, { signal });
          video.addEventListener('pause', () => this.updateButton(), { signal });
          video.addEventListener('error', () => {
            this.states.get(video).failed = true;
            this.states.get(video).pending = false;
            video.pause();
            this.updateButton();
          }, { signal });
        });

        this.toggle.addEventListener('click', () => {
          const active = this.videos.some(video => !video.paused || this.states.get(video).pending);
          this.playRequested = !active;
          if (this.playRequested) {
            this.states.forEach(state => { state.blocked = false; });
          }
          this.syncPlayback();
        }, { signal });

        document.addEventListener('visibilitychange', () => this.syncPlayback(), { signal });
        this.motionPreference.addEventListener('change', event => {
          if (event.matches) {
            this.playRequested = false;
            this.syncPlayback();
          }
        }, { signal });
        this.connection?.addEventListener?.('change', () => {
          if (this.connection.saveData) {
            this.playRequested = false;
            this.syncPlayback();
          }
        }, { signal });

        this.observer = new IntersectionObserver(entries => {
          const entry = entries[0];
          this.inView = entry.isIntersecting && entry.intersectionRatio >= 0.15;
          this.syncPlayback();
        }, { threshold: [0, 0.15] });
        this.observer.observe(this);
        this.updateButton();
      }

      shouldPlay() {
        return this.isConnected && this.inView && this.playRequested && !document.hidden;
      }

      syncPlayback() {
        if (!this.shouldPlay()) {
          this.videos.forEach(video => video.pause());
          this.updateButton();
          return;
        }
        this.videos.forEach(video => {
          const state = this.states.get(video);
          if (state.failed || state.blocked || state.pending || !video.paused) return;
          if (!video.getAttribute('src')) video.src = video.dataset.src;
          state.pending = true;
          Promise.resolve(video.play()).then(() => {
            state.pending = false;
            if (!this.shouldPlay()) video.pause();
            this.updateButton();
          }).catch(() => {
            state.pending = false;
            if (this.shouldPlay()) state.blocked = true;
            this.updateButton();
          });
        });
        this.updateButton();
      }

      updateButton() {
        if (!this.toggle || !this.states) return;
        const playing = this.shouldPlay() && this.videos.some(video => !video.paused || this.states.get(video).pending);
        this.dataset.playing = String(playing);
        this.toggle.setAttribute('aria-label', playing ? this.dataset.pauseLabel : this.dataset.playLabel);
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.observer?.disconnect();
        this.videos?.forEach(video => video.pause());
        this.abortController = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orlivy-mx-pairing"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('orlivy-pdp-styling')) {
  customElements.define('orlivy-pdp-styling', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (this.isConnected) this.initialize();
      });
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.abortController = null;
    }

    initialize() {
      if (this.abortController) return;
      const tablist = this.querySelector('[data-pdp-pairing-tabs]');
      const tabs = Array.from(this.querySelectorAll('[data-pdp-pairing-tab]'));
      const availablePanels = Array.from(this.querySelectorAll('[data-pdp-pairing-panel]'));
      const panels = tabs.map(tab => availablePanels.find(panel => panel.id === tab.dataset.panelId));
      if (!tablist || tabs.length < 2 || panels.some(panel => !panel)) return;

      this.abortController = new AbortController();
      const { signal } = this.abortController;
      this.tabs = tabs;
      this.panels = panels;
      tablist.setAttribute('role', 'tablist');
      tablist.setAttribute('aria-orientation', 'horizontal');

      tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', panels[index].id);
        panels[index].setAttribute('role', 'tabpanel');
        panels[index].setAttribute('aria-labelledby', tab.id);
        const heading = panels[index].querySelector('[data-pdp-pairing-heading]');
        if (heading) heading.hidden = true;
        tab.addEventListener('click', () => this.activate(index), { signal });
        tab.addEventListener('focus', () => this.activate(index), { signal });
      });

      tablist.addEventListener('keydown', event => {
        const tab = event.target.closest('[data-pdp-pairing-tab]');
        const currentIndex = tabs.indexOf(tab);
        if (currentIndex < 0) return;
        const direction = getComputedStyle(tablist).direction === 'rtl' ? -1 : 1;
        let nextIndex;
        if (event.key === 'ArrowRight') nextIndex = (currentIndex + direction + tabs.length) % tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (currentIndex - direction + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        if (nextIndex === undefined) return;
        event.preventDefault();
        this.activate(nextIndex, true);
      }, { signal });

      this.activate(0);
      tablist.hidden = false;
    }

    activate(index, moveFocus = false) {
      this.tabs.forEach((tab, tabIndex) => {
        const selected = tabIndex === index;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        this.panels[tabIndex].hidden = !selected;
      });
      if (moveFocus) this.tabs[index].focus();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orlivy-pdp-category-focus"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('orlivy-pdp-category-switcher')) {
  customElements.define('orlivy-pdp-category-switcher', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (this.isConnected) this.initialize();
      });
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.resizeObserver?.disconnect();
      this.resizeObserver = null;
      this.abortController = null;
    }

    initialize() {
      if (this.abortController) return;
      const tablist = this.querySelector('[data-category-tabs]');
      const tabs = Array.from(this.querySelectorAll('[data-category-tab]'));
      const availablePanels = Array.from(this.querySelectorAll('[data-category-panel]'));
      const panels = tabs.map(tab => availablePanels.find(panel => panel.id === tab.dataset.panelId));
      if (!tablist || !tabs.length || panels.some(panel => !panel)) return;

      let initialIndex = tabs.findIndex(tab => tab.getAttribute('aria-selected') === 'true' || tab.getAttribute('aria-current') === 'true');
      if (initialIndex < 0) initialIndex = 0;

      this.abortController = new AbortController();
      const { signal } = this.abortController;
      this.tabs = tabs;
      this.panels = panels;
      this.tablist = tablist;
      this.scrollButtons = Array.from(this.querySelectorAll('[data-category-scroll]'));
      this.scrollButtons.forEach(button => {
        button.addEventListener('click', () => {
          const direction = getComputedStyle(tablist).direction === 'rtl' ? -1 : 1;
          const step = Math.max(180, tablist.clientWidth * 0.8);
          const sign = button.dataset.categoryScroll === 'next' ? 1 : -1;
          tablist.scrollBy({ left: step * sign * direction, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        }, { signal });
      });
      tablist.addEventListener('scroll', () => this.updateScrollControls(), { signal, passive: true });
      this.resizeObserver = new ResizeObserver(() => { this.revealCurrentTab(); this.updateScrollControls(); });
      this.resizeObserver.observe(tablist);
      document.fonts.ready.then(() => { if (this.isConnected) { this.revealCurrentTab(); this.updateScrollControls(); } });
      tablist.setAttribute('role', 'tablist');
      tablist.setAttribute('aria-orientation', 'horizontal');

      tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', panels[index].id);
        tab.closest('li')?.setAttribute('role', 'presentation');
        panels[index].setAttribute('role', 'tabpanel');
        panels[index].setAttribute('aria-labelledby', tab.id);
        panels[index].tabIndex = 0;
        tab.addEventListener('click', event => {
          if (event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.activate(index, false, true);
        }, { signal });
        tab.addEventListener('focus', () => this.activate(index, false, true), { signal });
      });

      tablist.addEventListener('keydown', event => {
        if (event.metaKey || event.ctrlKey || event.altKey) return;
        const tab = event.target.closest('[data-category-tab]');
        const currentIndex = tabs.indexOf(tab);
        if (currentIndex < 0) return;
        const direction = getComputedStyle(tablist).direction === 'rtl' ? -1 : 1;
        let nextIndex;
        if (event.key === 'ArrowRight') nextIndex = (currentIndex + direction + tabs.length) % tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (currentIndex - direction + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        if (event.key === ' ' || event.key === 'Enter') nextIndex = currentIndex;
        if (nextIndex === undefined) return;
        event.preventDefault();
        this.activate(nextIndex, true, true);
      }, { signal });

      this.activate(initialIndex, false, true);
      this.updateScrollControls();
    }

    updateScrollControls() {
      if (!this.tablist || !this.tabs.length) return;
      const overflow = this.tablist.scrollWidth > this.tablist.clientWidth + 2;
      const bounds = this.tablist.getBoundingClientRect();
      const first = this.tabs[0].getBoundingClientRect();
      const last = this.tabs[this.tabs.length - 1].getBoundingClientRect();
      const rtl = getComputedStyle(this.tablist).direction === 'rtl';
      this.scrollButtons.forEach(button => {
        button.hidden = !overflow;
        button.disabled = button.dataset.categoryScroll === 'previous'
          ? (rtl ? first.right <= bounds.right + 2 : first.left >= bounds.left - 2)
          : (rtl ? last.left >= bounds.left - 2 : last.right <= bounds.right + 2);
      });
    }

    revealCurrentTab() {
      const tab = this.tabs[this.activeIndex];
      if (!tab) return;
      const bounds = this.tablist.getBoundingClientRect();
      const selected = tab.getBoundingClientRect();
      if (selected.left < bounds.left) this.tablist.scrollBy({ left: selected.left - bounds.left - 4 });
      else if (selected.right > bounds.right) this.tablist.scrollBy({ left: selected.right - bounds.right + 4 });
    }

    async loadCollection(panel) {
      if (panel.dataset.loadState === 'loading' || panel.dataset.loadState === 'ready') return;
      const grid = panel.querySelector('[data-remote-products]');
      const status = panel.querySelector('[data-load-status]');
      const scope = this.abortController.signal;
      const controller = new AbortController();
      const cancel = () => controller.abort();
      scope.addEventListener('abort', cancel, { once: true });
      const timeout = window.setTimeout(cancel, 12000);
      panel.dataset.loadState = 'loading';
      grid.setAttribute('aria-busy', 'true');
      status.textContent = 'Cargando productos…';
      status.hidden = false;
      try {
        const url = new URL(panel.dataset.loadCollection, location.origin);
        url.searchParams.set('section_id', 'orlivy-explora-products');
        const preview = new URLSearchParams(location.search).get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        const response = await fetch(url, { signal: controller.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error('Collection unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const results = doc.querySelector('[data-explora-results]');
        if (!results || scope.aborted) throw new Error('Collection unavailable');
        const items = Array.from(results.querySelectorAll('template[data-product-id]'))
          .filter(item => item.dataset.productId !== this.dataset.productId)
          .slice(0, Number(this.dataset.cardLimit));
        const cards = document.createDocumentFragment();
        for (const item of items) {
          const card = document.importNode(item.content, true);
          const title = card.querySelector('h3');
          const link = card.querySelector('a[aria-labelledby]');
          if (title && link) {
            title.id = panel.id + '-item-' + item.dataset.productId;
            link.setAttribute('aria-labelledby', title.id);
          }
          cards.append(card);
        }
        grid.replaceChildren(cards);
        grid.hidden = items.length === 0;
        panel.classList.toggle('olv-pdp-category__focus--single', items.length === 1);
        panel.classList.toggle('olv-pdp-category__focus--compact', items.length === 2);
        grid.parentElement.style.setProperty('--olv-focus-columns', Math.max(2, items.length));
        status.textContent = items.length ? '' : this.dataset.emptyLabel;
        status.hidden = items.length > 0;
        panel.dataset.loadState = 'ready';
      } catch {
        delete panel.dataset.loadState;
        if (!scope.aborted) status.textContent = 'Puedes abrir la colección para ver sus productos.';
      } finally {
        grid.removeAttribute('aria-busy');
        window.clearTimeout(timeout);
        scope.removeEventListener('abort', cancel);
      }
    }

    activate(index, moveFocus = false, revealTab = false) {
      const changed = this.activeIndex !== index;
      this.activeIndex = index;
      this.tabs.forEach((tab, tabIndex) => {
        const selected = tabIndex === index;
        tab.removeAttribute('aria-current');
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        if (selected) {
          const content = this.panels[tabIndex].querySelector('template[data-category-content]');
          if (content) content.replaceWith(content.content.cloneNode(true));
          if (this.panels[tabIndex].hasAttribute('data-load-collection')) {
            this.loadCollection(this.panels[tabIndex]);
          }
        }
        this.panels[tabIndex].hidden = !selected;
      });
      if (changed) this.dispatchEvent(new CustomEvent('orlivy:explore-collection', { bubbles: true }));
      if (moveFocus) this.tabs[index].focus({ preventScroll: true });
      if (revealTab) this.revealCurrentTab();
      this.updateScrollControls();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orlivy-pdp-featured"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('orlivy-pdp-featured')) {
  customElements.define('orlivy-pdp-featured', class extends HTMLElement {
    connectedCallback() {
      this.scope = new AbortController();
      this.near = false;
      const sync = () => {
        const active = document.querySelector('orlivy-pdp-category-switcher [data-category-tab][aria-selected="true"], orlivy-pdp-category-switcher [data-category-tab][aria-current="true"]');
        const panels = Array.from(this.querySelectorAll('[data-featured-collection]'));
        const used = new Set([active?.dataset.collectionHandle]);
        let selected;
        for (const shelf of document.querySelectorAll('orlivy-pdp-featured')) {
          const choice = Array.from(shelf.querySelectorAll('[data-featured-collection]')).find(panel => !used.has(panel.dataset.featuredCollection));
          if (shelf === this) { selected = choice; break; }
          if (choice) used.add(choice.dataset.featuredCollection);
        }
        for (const panel of panels) panel.hidden = panel !== selected;
        if (this.near && selected) this.loadCards(selected);
      };
      for (const panel of this.querySelectorAll('[data-featured-collection][data-loaded]')) {
        this.bindCarousel(panel, panel.querySelector('.olv-featured__grid'));
      }
      document.addEventListener('orlivy:explore-collection', sync, { signal: this.scope.signal });
      this.observer = new IntersectionObserver(entries => {
        this.near = entries.some(entry => entry.isIntersecting);
        if (this.near) sync();
      }, { rootMargin: '320px 0px' });
      this.observer.observe(this);
      queueMicrotask(() => { if (this.isConnected) sync(); });
    }
    disconnectedCallback() {
      this.scope.abort();
      this.observer.disconnect();
    }
    bindCarousel(panel, grid) {
      const controls = panel.querySelector('.olv-featured__controls');
      if (grid.children.length <= 2) return;
      const [previous, next] = controls.querySelectorAll('button');
      const position = controls.querySelector('.olv-featured__position');
      const signal = this.scope.signal;
      const update = () => {
        const max = grid.scrollWidth - grid.clientWidth;
        controls.hidden = max < 2;
        previous.disabled = grid.scrollLeft <= 2;
        next.disabled = grid.scrollLeft >= max - 2;
        position.textContent = (grid.scrollLeft > max / 2 ? '2' : '1') + ' / 2';
      };
      controls.addEventListener('click', event => {
        const button = event.target.closest('[data-step]');
        if (button) grid.scrollTo({ left: button.dataset.step === '1' ? grid.scrollWidth : 0,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }, { signal });
      grid.addEventListener('scroll', update, { passive:true, signal });
      const observer = new ResizeObserver(update);
      observer.observe(grid);
      signal.addEventListener('abort', () => observer.disconnect(), { once:true });
      update();
    }
    async loadCards(panel) {
      if (panel.dataset.loaded || panel.hasAttribute('aria-busy')) return;
      const url = new URL(panel.querySelector('header a').href);
      url.searchParams.set('section_id', 'orlivy-pdp-featured');
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      panel.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(url, { signal: this.scope.signal });
        if (!response.ok) return;
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const results = doc.querySelector('[data-featured-results]');
        if (!results || !this.isConnected) return;
        const items = Array.from(results.querySelectorAll('template[data-featured-item]'))
          .filter(item => item.dataset.featuredItem !== this.dataset.product).slice(0, 4);
        const grid = panel.querySelector('.olv-featured__grid');
        for (const item of items) {
          const card = document.importNode(item.content, true);
          const id = 'FeaturedItem-' + this.dataset.section + '-' + panel.dataset.featuredCollection + '-' + item.dataset.featuredItem;
          card.querySelector('h3').id = id;
          card.querySelector('a').setAttribute('aria-labelledby', id);
          grid.append(card);
        }
        this.bindCarousel(panel, grid);
        panel.dataset.loaded = 'true';
      } catch {
        // The collection link remains usable, and entering the viewport again retries.
      } finally {
        panel.removeAttribute('aria-busy');
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
